import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

import FansiWinSlider from '@/organisms/FansiWinSlider'

const SLIDES = [
  {
    id: 1,
    title: 'Martyna',
    uri: '/images/fansi-win/Martyna.png',
    url: 'https://www.instagram.com/slowik.martynaa/',
  },
  {
    id: 2,
    title: 'Eli',
    uri: '/images/fansi-win/Eli.png',
    url: 'https://www.instagram.com/not.my.high/',
  },
  {
    id: 3,
    title: 'Marta',
    uri: '/images/fansi-win/Marta.png',
    url: 'https://www.instagram.com/polishjungle/',
  },
  {
    id: 5,
    title: 'Alicja',
    uri: '/images/fansi-win/Alicja.jpg',
    url: 'https://www.instagram.com/wegannerdblog/',
  },
  {
    id: 4,
    title: 'Kinga',
    uri: '/images/fansi-win/Kinga.jpg',
    url: 'https://www.instagram.com/crispynka/',
  },
]

function Carousel() {
  const { t } = useTranslation('fansiWin')

  return (
    <div className="flex flex-col w-full py-14 lg:py-24">
      <div className="flex flex-col items-center justify-center gap-4 pb-4">
        <h2 className="text-[#839abd] text-xl 2xl:text-2xl font-medium">
          {t('selected_creators')}
        </h2>
        <Image src="/assets/fansi-win/arrow-down.png" width={20} height={24} />
      </div>
      <FansiWinSlider slides={SLIDES} />
    </div>
  )
}

export default Carousel
